const { inExperiment } = require('..');
const { MUSTANGS_BUSINESS_ENV_GIG_PAGE } = require('../experimentsEnum');

const inBusinessGigPageExperiment =  (abTests) => inExperiment(MUSTANGS_BUSINESS_ENV_GIG_PAGE, abTests);

module.exports = {
    inBusinessGigPageExperiment
};
